import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 4v20H10.02L1 14.83 2.9 13 8 15.91V3h3v8h1V0h3v11h1V1h3v10h1V4h3z"
}), 'PanToolSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PanToolSharp.js
// module id = 5184
// module chunks = 2